/**
 * Created by bing on 2018/3/30.
 */
module.exports = function (Vue, options) {
  Vue.filter('DateFilter', function (value) {
    return value ? new Date(value).pattern("yyyy-MM-dd") : '-'

  })
  Vue.filter('DefaultFilter', function (value) {
    return val
  })
  //------时间过滤器------
  Vue.filter('DayTimer', function (value) {
    return value ? new Date(value).pattern("yyyy-MM-dd") : '-'

  })
  Vue.filter('MinTimer', function (value) {
    return value ? new Date(value).pattern("yyyy-MM-dd HH:mm") : '-'

  })
  Vue.filter('SecondTimer', function (value) {
    return value ? new Date(value).pattern("yyyy-MM-dd HH:mm:ss") : '-'

  })
  Vue.filter('WorkTime', function (value) {
    return value ? (value.substring(0, 2) + ":" + value.substring(2, 4)) : ''

  })

};



// WEBPACK FOOTER //
// ./src/utils/filter.js